export type MetaListItem = {
  "@type": string;
  position: number;
  name: string;
  item?: string;
};

type MakeMetaListItem = (name: string, position: number, item?: string) => MetaListItem;

export const metaListItem: MakeMetaListItem = (name, position, item) => {
  const schema: MetaListItem = {
    "@type": "ListItem",
    position,
    name,
  };

  if (item) {
    schema.item = item;
  }

  return schema;
};

export const metaSchema = (itemListElement: MetaListItem[]) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  });
